const initialState = {
  loading: false,
  coverImages: [],
  error: null,
};

const teamCoverImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_TEAM_COVERIMAGE_REQUEST":
    case "UPDATE_TEAM_COVERIMAGE_REQUEST":
      case "DELETE_TEAM_COVERIMAGE_REQUEST":

      return { ...state, loading: true, error: null };

      case "SAVE_TEAM_COVERIMAGE_SUCCESS":
        return {
          ...state,
          loading: false,
          coverImages: [...state.coverImages, action.payload],
        };
      

    case "UPDATE_TEAM_COVERIMAGE_SUCCESS": {
      const updated = action.payload;
      const memberObjId = updated?.memberObjId;
      const exists = state.coverImages.some((img) => img.memberObjId === memberObjId);

      return {
        ...state,
        loading: false,
        coverImages: exists
          ? state.coverImages.map((img) =>
              img.memberObjId === memberObjId ? { ...img, ...updated } : img
            )
          : [...state.coverImages, updated],
      };
    }
    case "DELETE_TEAM_COVERIMAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        coverImages: state.coverImages.filter(
          (img) =>
            !(
              img.memberObjId === action.payload.memberObjId &&
              img.memberimageObjId === action.payload.memberimageObjId
            )
        ),
      };

    case "SAVE_TEAM_COVERIMAGE_FAILURE":
    case "UPDATE_TEAM_COVERIMAGE_FAILURE":
      case "DELETE_TEAM_COVERIMAGE_FAILURE":

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default teamCoverImageReducer;
